import React, {
  useState,
  useEffect,
  Fragment,
  lazy,
  Suspense,
  useContext
} from 'react';
import BasicInfocards from './BasicInfocards';
import styles from './CMDashboard.module.css';
import CMProfessionalDataBoard from './CMProfessionalDataBoard';
import shuffle from 'lodash/shuffle';
import LoanDetails from './LoanDetails';
import CommonBtn from '../../containers/LeadProfile/CommonBtn/CommonBtn';
import Modal from '../../common/components/Modal/modal';
import CMKycDocViewer from '../../common/components/CMKycDocViewer/CMKycDocViewer';
import CircularLoading from '../../common/components/CircularLoading/CircularLoading';
import CMDashboardIncomeData from './CMDashboardIncomeData';
import {
  getInPrincipleDocs,
  getInfoForInPrinciple,
  checkApproval,
  getPropertyDetails,
  getLeadProfileStatus,
  hardRejectTheApplication
} from '../../common/constants/api';
import {
  getApplicantionInfo,
  setApplicantionInfo
} from '../../common/utils/applicantionInfo';
import PopUp from '../../common/components/PopUp/PopUp';
import RejectModal from '../CMDocView/RejectModal';
import * as _ from 'lodash';
import { numberFormat } from '../../common/constants/NumberFormat';
import CommonComment from '../../components/CommonComment/CommonComment';
import withErrorHandler from '../../hoc/withErrorHandler/withErrorHandler';
const experian = '/images/icons/CreditReport/experianImage.png';
import CancelRoundedIcon from '@material-ui/icons/CancelRounded';
import {
  ApplicantHeading,
  CardHeading
} from '../../components/CompanyDetailsCMView/CompanyDetailsCMView';
import WhatsAppDoc from './WhatsAppDoc';
import { navigate } from 'gatsby';
import { bankStatementCmView } from 'gatsby-env-variables';

import UploadedBankStatement from '../../common/components/UploadedBankStatements/UploadedBankStatement';
const CompanyDetails = lazy(() =>
  import('../../components/CompanyDetailsCMView/CompanyDetailsCMView')
);
import KycBreReport from '../../containers/BRE/KycBREReport/KycBreReport';
const { overViewHandler, widthFit, circle, listStyleNone, showDiv } = styles;

const LeadParameter = [
  { name: 'Basic Information' },
  {
    name: 'KYC',
    subOptions: ['PAN Card', 'Aadhaar Card', 'Other Address Proof']
  },
  { name: 'Professional Details' },
  {
    name: 'Income Details',
    subOptions: ['Salary Slip', 'Bank Statement', 'Form 16', 'ITR']
  },
  { name: 'Obligation Details' },
  { name: 'Company Details' },
  {
    name: 'Company Documents',
    subOptions: [
      'MOA',
      'AOA',
      'Share Holding',
      'Board Resolution',
      'Company Registration',
      'Partnership Deed',
      'LLP Agreement'
    ]
  },
  {
    name: 'Property Details',
    subOptions: ['Summary', 'Cost Sheet']
  },

  bankStatementCmView && {
    name: 'Bank Statement'
  },

  {
    name: 'Credit Score'
  },
  { name: 'Whats App Document' },
  { name: 'BRE' }
];
const loading = (
  <div className="w-full flex content-center items-center relative -ml-10 ">
    <div className="absolute inset-1/2 mt-40 ">
      <CircularLoading />
    </div>
  </div>
);

export const ReadOnly = React.createContext(false);
const CMDetailView = ({
  setHighlightedOpt,
  setFullImage,
  setIsError,
  setFile,
  MenuOnclickHandler,
  hardReject,
  setHardReject,
  setShowAnlyseButton,
  analyzeTheBre,
  setShowAnalyseBtn
}) => {
  const [leadId, setLeadId] = useState(getApplicantionInfo().leadId);
  const [show, setShow] = useState(false);
  const [popUpShow, setPopUpShow] = useState(false);
  const [popUpType, setPopUpType] = useState('loading');
  const [popUpText, setPopUpText] = useState('Processing request...');
  const [current, setCurrent] = useState('Basic Information');
  const [currentAction, setCurrentAction] = useState(null);
  const [inReject, setInReject] = useState(false);
  const [isRejected, setIsRejected] = useState(false);
  const [moveToInPrinciple, setMoveToInPrinciple] = useState(false);
  const [inPrincipalShow, setInPrincipalShow] = useState(false);
  const [canCreate, setCanCreate] = useState(false);
  const [reason, setReason] = useState('Do you want to move to in principle?');

  const isReadOnly = useContext(ReadOnly);

  let bgAndTextColors = [
    {
      bgcolor: '#f9ecf9',
      textcolor: '#DA70D6'
    },
    {
      bgcolor: '#e8f8f1',
      textcolor: '#65B7BC'
    },
    {
      bgcolor: '#fcf6e6',
      textcolor: '#D7B17E'
    },
    {
      bgcolor: '#fad4db',
      textcolor: '#FA8072'
    }
  ];

  bgAndTextColors = shuffle(bgAndTextColors);

  useEffect(() => {
    setInReject(true);
    return () => setInReject(false);
  }, [inReject]);

  let principleApproval = () => {
    setPopUpShow(true);
    checkApproval(leadId).then(res => {
      res.canCreate ? setCanCreate(true) : setCanCreate(false);
      res.comment != null
        ? setReason(res.comment)
        : setReason('Do you want to move to in principle?');
      setPopUpShow(false);
      setMoveToInPrinciple(true);
      setInPrincipalShow(true);
    });
  };
  let MoveToInPriciple = () => {
    setHighlightedOpt(1);
    MenuOnclickHandler(1);
  };
  const kycSubActionHandler = () => {
    switch (currentAction) {
      case 'PAN Card':
        return (
          <CMKycDocViewer
            setFullImage={setFullImage}
            setIsError={setIsError}
            setFile={setFile}
            title="PAN Card"
            docType="pan"
          />
        );
      case 'Aadhaar Card':
        return (
          <CMKycDocViewer
            setFullImage={setFullImage}
            setIsError={setIsError}
            setFile={setFile}
            title="Aadhaar Card"
            docType="aadhaar"
          />
        );
      case 'Other Address Proof':
        return (
          <CMKycDocViewer
            setFullImage={setFullImage}
            setIsError={setIsError}
            setFile={setFile}
            title="Other Address Proof"
            docType="address-proof"
          />
        );
      default:
        return null;
    }
  };
  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    if (urlParams.get('currentState') == 'creditReport')
      setCurrent('Credit Score');
  }, []);

  const showRejectModal = () => {
    setInPrincipalShow(false);
    setHardReject(true);
  };
  return (
    <div className="w-full px-4">
      {!isReadOnly ? (
        <React.Fragment>
          <div className={`flex ml-auto ${widthFit} my-2`}>
            <div className="text-center ">
              <CommonBtn
                value="Docs Incomplete"
                disabled={isRejected}
                stylesBtn={{
                  ...(!isRejected
                    ? { backgroundColor: '#f6ad55' }
                    : { backgroundColor: '#c7c6c6' }),
                  color: '#FFFFFF',
                  width: '10rem',
                  marginLeft: '5px',
                  marginRight: '5px',
                  padding: '10px',
                  textAlign: 'center',
                  borderRadius: '5px',
                  display: 'block',
                  ...(!isRejected
                    ? { border: '1px solid #f6ad55' }
                    : { border: '1px solid #c7c6c6' })
                }}
                onClick={() => {
                  setInReject(!inReject);
                  setShow(true);
                }}
              />
            </div>
            <div className="">
              <CommonBtn
                value="Move to In-principle"
                stylesBtn={{
                  backgroundColor: '#00ACB8',
                  color: '#FFFFFF',
                  width: 'auto',
                  marginLeft: '5px',
                  marginRight: '5px',
                  padding: '10px',
                  textAlign: 'center',
                  borderRadius: '5px',
                  display: 'block'
                }}
                onClick={() => {
                  principleApproval();
                }}
              />
            </div>
          </div>
          <HardRejection show={hardReject} setShow={setHardReject} />
          {inReject && (
            <Modal
              show={show}
              setShow={setShow}
              styleContainer={{
                width: '395px'
              }}
            >
              <Fragment>
                <RejectModal setIsRejected={setIsRejected} leadId={leadId} />
              </Fragment>
            </Modal>
          )}
          {moveToInPrinciple ? (
            <Modal
              show={inPrincipalShow}
              setShow={setInPrincipalShow}
              styleContainer={{
                width: '395px'
              }}
              noCloseBtn={false}
            >
              <div className="w-full text-center">
                <p className="font-roboto text-xl font-bold text-black-400 text-center py-4">
                  In Principle Indication
                </p>
                <p className="font-roboto font-normal text-black-400 text-center py-2">
                  {reason}
                </p>
              </div>
              {canCreate ? (
                <div className="w-full flex mt-8">
                  <button
                    className="text-black-100 px-3 py-2 border border-balck-500 rounded-md font-roboto font-normal hover:bg-grey-100"
                    onClick={() => {
                      setInPrincipalShow(false);
                      setMoveToInPrinciple(false);
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    className="ml-auto bg-tealCol-100 border text-white rounded-md font-roboto font-normal px-5 py-2 hover:bg-green-1100"
                    onClick={() => MoveToInPriciple()}
                  >
                    Yes
                  </button>
                </div>
              ) : null}
            </Modal>
          ) : null}
        </React.Fragment>
      ) : null}

      <div
        className={`w-full min-h-screen  bg-white border-navy-400   border flex flex-wrap ${
          isReadOnly ? 'mt-8' : ''
        }`}
      >
        <div className="w-full md:flex md:flex-wrap ">
          <div className={` block ${overViewHandler} mr-auto `}>
            <BasicDetails
              current={current}
              setCurrent={setCurrent}
              currentAction={currentAction}
              setCurrentAction={setCurrentAction}
              setShowAnlyseButton={setShowAnlyseButton}
            />
          </div>
          <div className="w-full relative mx-auto px-5 md:pl-10 flex-1 overflow-auto">
            {current == 'Basic Information' ? (
              <BasicOverView colorObj={bgAndTextColors} />
            ) : null}
            {current == 'KYC' ? kycSubActionHandler() : null}
            {current == 'Professional Details' ? <ProfessionalDetails /> : null}
            {current == 'Obligation Details' ? <GetLoanDetails /> : null}
            {current == 'Income Details' ? (
              <CMDashboardIncomeDetails
                setFullImage={setFullImage}
                setIsError={setIsError}
                setFile={setFile}
                currentAction={currentAction}
                // isError={isError}
                current={current}
              />
            ) : null}
            {current == 'Property Details' ? (
              <GetPropertyDetails
                currentAction={currentAction}
                current={current}
                setFullImage={setFullImage}
                setIsError={setIsError}
                setFile={setFile}
                setCurrentAction={setCurrentAction}
              />
            ) : null}
            {current == 'Company Details' ? (
              <Suspense fallback={<CircularLoading />}>
                <CompanyDetails />
              </Suspense>
            ) : null}
            {current == 'Company Documents' ? (
              <Suspense fallback={<CircularLoading />}>
                <CMDashboardIncomeDetails
                  currentAction={currentAction}
                  setFullImage={setFullImage}
                  setIsError={setIsError}
                  setFile={setFile}
                />
              </Suspense>
            ) : null}
            {bankStatementCmView && current == 'Bank Statement' ? (
              <UploadedBankStatement leadId={leadId} />
            ) : null}

            {current == 'Credit Score' ? <CreditReport /> : null}
            {current == 'Whats App Document' ? (
              <WhatsAppDoc leadId={leadId} />
            ) : null}
            {current === 'BRE' && (
              <KycBreReport analyzeTheBre={analyzeTheBre} leadId={leadId} setShowAnalyseBtn={setShowAnalyseBtn} />
            )}
          </div>
        </div>
      </div>
      <PopUp
        type={popUpType}
        text={popUpText}
        dontClose
        setShow={setPopUpShow}
        show={popUpShow}
      />
    </div>
  );
};

const BasicDetails = ({
  current,
  setCurrent,
  currentAction,
  setCurrentAction,
  setShowAnlyseButton
}) => {
  return (
    <div className="w-full mb-12">
      {LeadParameter.map((each, i) => {
        if (!each) return <Fragment />;
        return (
          <div key={i} className="w-full">
            <div
              className={`${
                current == each.name ? 'bg-green-600' : 'white'
              }  border-blue-1102 pl-2  border cursor-pointer`}
            >
              <div
                className={`${
                  current == each.name ? 'bg-navy-300' : 'white'
                } py-3 `}
                onClick={() => {
                  setCurrent(each.name);
                  setShowAnlyseButton(each.name);
                  if (each.name === 'KYC') {
                    setCurrentAction('PAN Card');
                  }
                  if (each.name === 'Income Details') {
                    setCurrentAction('Salary Slip');
                  }
                  if (each.name === 'Property Details') {
                    setCurrentAction('Summary');
                  }
                  if (each.name === 'Company Documents') {
                    setCurrentAction('MOA');
                  }
                }}
              >
                <span
                  className={`${
                    current == each.name ? 'font-bold ' : 'font-normal'
                  } text-black-1011 font-roboto text-sm ml-4`}
                >
                  {each.name}
                </span>
              </div>
            </div>

            {current == each.name && each.subOptions ? (
              <div
                className={`w-full block border border-navy-500 bg-white px-3 py-4 ${showDiv}`}
              >
                {each.subOptions
                  ? each.subOptions.map(every => {
                      return (
                        <div className={`flex items-center my-1`}>
                          <p
                            className={`${circle} ${
                              currentAction == every
                                ? 'bg-orange-1100'
                                : 'bg-black-0'
                            } `}
                          ></p>
                          <li
                            className={`w-full ${
                              currentAction == every
                                ? 'text-orange-1100'
                                : 'text-black-0'
                            } text-sm font-roboto font-normal mt-2 cursor-pointer ml-3  ${listStyleNone}`}
                            onClick={() => setCurrentAction(every)}
                          >
                            {every}
                          </li>
                        </div>
                      );
                    })
                  : null}
              </div>
            ) : null}
          </div>
        );
      })}
    </div>
  );
};

const BasicOverView = ({ colorObj }) => {
  const [text, setText] = useState('loading');
  const [show, setShow] = useState(false);
  const [basicData, setBasicData] = useState([]);
  const [isGetOver, setIsGetOver] = useState(false);
  let randomCol = colorObj[Math.floor(Math.random() * colorObj.length)];

  useEffect(() => {
    setIsGetOver(false);
    getInfoForInPrinciple(getApplicantionInfo().leadId, 'basic-information')
      .then(res => {
        if (res.error) {
          throw new Error(res);
        }
        setBasicData(res);
        setIsGetOver(true);
      })
      .catch(error => {
        if (error?.response?.status === 403) {
          setShow(true);
          setText(error?.response?.data?.message.toString());
        }
        setIsGetOver(true);
      });
  }, []);

  if (isGetOver) {
    return (
      <div className="mx-auto mb-12">
        <div className="block w-full mt-4">
          <div className="my-3">
            <ApplicantHeading heading="Main Applicant" />
          </div>
          <BasicInfocards
            each={_.get(basicData, 'mainApplicant', false)}
            bg={randomCol.bgcolor}
            text={randomCol.textcolor}
            loanAmount={basicData.loanAmount}
            product={basicData.loanProduct}
            loanSubProduct={basicData.loanSubProduct}
          />
        </div>
        {basicData.coApplicants?.map((each, index) => {
          return (
            <div className="block w-full mt-4">
              <div className="my-3">
                <ApplicantHeading heading={`Co-applicant ${index + 1}`} />
              </div>
              <BasicInfocards each={each} coapplicant={true} />
            </div>
          );
        })}

        {show && (
          <PopUp
            type={'fail'}
            text={text}
            goto={true}
            dontClose
            setShow={setShow}
            show={show}
          />
        )}
      </div>
    );
  } else {
    return loading;
  }
};

const ProfessionalDetails = () => {
  const [professionalData, setProfessionalData] = useState([]);
  const [type, setType] = useState('loading');
  const [text, setText] = useState('loading');
  const [show, setShow] = useState(false);
  const [isGetOver, setIsGetOver] = useState(false);

  useEffect(() => {
    setIsGetOver(false);
    getInfoForInPrinciple(getApplicantionInfo().leadId, 'professional-details')
      .then(res => {
        if (res.error) {
          throw new Error(res);
        }
        setShow(false);
        setProfessionalData(res);
        setIsGetOver(true);
      })
      .catch(error => {
        setType('fail');
        setText(error?.response?.data?.message.toString());
        setShow(true);
        setIsGetOver(true);
      });
  }, []);
  if (isGetOver) {
    return (
      <div className="w-full block mb-12">
        {professionalData.map((each, index) => {
          return <CMProfessionalDataBoard each={each} index={index} />;
        })}
        <PopUp type={type} text={text} setShow={setShow} show={show} />
      </div>
    );
  } else {
    return loading;
  }
};

const CMDashboardIncomeDetails = React.memo(
  withErrorHandler(
    ({ setFullImage, setIsError, setFile, currentAction, current }) => {
      const [incomeData, setIncomeData] = useState([]);

      const [isGetOver, setIsGetOver] = useState(false);
      const [isDataAvailable, setDataAvailable] = useState(true);
      const [updateTrigger, setUpdateTrigger] = useState(false);

      useEffect(() => {
        if (currentAction == 'Salary Slip') callIncomeApi('salary-slips', true);
        else if (currentAction == 'Bank Statement')
          callIncomeApi('bank-statements', true);
        else if (currentAction == 'Form 16') callIncomeApi('form-16', true);
        else if (currentAction == 'ITR') callIncomeApi('itr', true);
        else if (currentAction == 'MOA') callIncomeApi('moa', true);
        else if (currentAction == 'AOA') callIncomeApi('aoa', true);
        else if (currentAction == 'Share Holding')
          callIncomeApi('share-holding', true);
        else if (currentAction == 'Board Resolution')
          callIncomeApi('board-resolution', true);
        else if (currentAction == 'Company Registration')
          callIncomeApi('company-registration', true);
        else if (currentAction == 'Partnership Deed')
          callIncomeApi('partnership-deed', true);
        else if (currentAction == 'LLP Agreement')
          callIncomeApi('llp-agreement', true);
      }, [updateTrigger, currentAction]);

      let callIncomeApi = (doc, forceUpdate) => {
        setIsGetOver(false);
        getInPrincipleDocs(getApplicantionInfo().leadId, doc)
          .then(res => {
            if (res.error) {
              throw new Error(res);
            }
            setIncomeData(res);
            setIsGetOver(true);
          })
          .catch(error => {
            setIncomeData([]);

            setIsGetOver(true);
          });
      };
      useEffect(() => {
        if (incomeData) {
          for (let i = 0; i < incomeData.length; i++) {
            if (incomeData[i].applicantDocs.length > 0) {
              setDataAvailable(true);
              break;
            } else {
              setDataAvailable(false);
            }
          }
        }
      }, [incomeData]);

      useEffect(() => {
        if (currentAction == 'Salary Slip')
          callIncomeApi('salary-slips', false);
        else if (currentAction == 'Bank Statement')
          callIncomeApi('bank-statements', false);
        else if (currentAction == 'Form 16') callIncomeApi('form-16', false);
        else if (currentAction == 'ITR') callIncomeApi('itr', false);
      }, [currentAction]);

      const isReadOnly = useContext(ReadOnly);

      if (isGetOver) {
        return (
          <React.Fragment>
            {isDataAvailable ? (
              <div className="w-full mb-12">
                <div className="text-green-600 text-xl font-roboto font-bold mt-5 mb-4">
                  Income Details - {currentAction}
                </div>
                {incomeData[0]?.applicantDocs?.length > 0 ? (
                  incomeData.map((each, index) => {
                    let firstDocId =
                      each?.applicantDocs.length > 0
                        ? each?.applicantDocs[each.applicantDocs.length - 1]
                            ?.link?.docId
                        : null;
                    if (each.applicantDocs?.length > 0)
                      return (
                        <div
                          className="font-roboto font-normal text-black-0 my-6 text-lg px-5 w-full "
                          key={index}
                        >
                          <div className="font-roboto font-medium text-base text-black-1003 px-5  py-3">
                            {index == 0 ? (
                              <ApplicantHeading heading="Main Applicant" />
                            ) : each?.applicantDocs?.length > 0 ? (
                              <ApplicantHeading
                                heading={`Co-applicant ${index}`}
                              />
                            ) : null}
                          </div>

                          <div className="flex flex-wrap w-full">
                            {each.applicantDocs?.map((every, index) => (
                              <div className="px-5">
                                <CMDashboardIncomeData
                                  key={index}
                                  updateTrigger={updateTrigger}
                                  setUpdateTrigger={setUpdateTrigger}
                                  fileTitle={`${currentAction}${
                                    every?.link?.tag
                                      ? ` - ${every?.link?.tag}`
                                      : ''
                                  }`}
                                  docId={every?.link?.docId}
                                  setFullImage={setFullImage}
                                  setIsError={setIsError}
                                  setFile={setFile}
                                  file={every?.link?.url}
                                  tag={every?.link?.tag}
                                  verified={every?.verified}
                                  isError
                                />
                              </div>
                            ))}
                            {!isReadOnly ? (
                              <div>
                                {each?.applicantDocs.length > 0 && (
                                  <CommonComment passAnyDocId={firstDocId} />
                                )}
                              </div>
                            ) : null}
                          </div>
                        </div>
                      );
                    else return null;
                  })
                ) : (
                  <div className="absolute inset-x-1/2 w-full mt-20 text-black-1003 text-base font-medium">
                    No Documents Available. .
                  </div>
                )}
              </div>
            ) : (
              <p className="w-full text-center font-roboto font-bold text-black-500 text-base items-center mt-9">
                No Data Available
              </p>
            )}
          </React.Fragment>
        );
      } else {
        return loading;
      }
    }
  )
);

const GetLoanDetails = () => {
  const [loanDetails, setLoanDetails] = useState([]);
  const [type, setType] = useState('loading');
  const [text, setText] = useState('loading');
  const [show, setShow] = useState(false);
  const [isGetOver, setIsGetOver] = useState(false);
  const [isDataAvaiilable, setDataAvailable] = useState(false);

  useEffect(() => {
    setIsGetOver(false);
    getInfoForInPrinciple(getApplicantionInfo().leadId, 'obligations')
      .then(res => {
        if (res.error) {
          throw new Error(res);
        }
        setIsGetOver(true);
        setShow(false);
        setLoanDetails(res);
      })
      .catch(error => {
        setType('fail');
        setText(error?.response?.data?.message.toString());
        setShow(true);
      });
  }, []);
  useEffect(() => {
    if (loanDetails) {
      for (let i = 0; i < loanDetails.length; i++) {
        if (loanDetails[i].obligations.length > 0) {
          setDataAvailable(true);
          break;
        } else {
          setDataAvailable(false);
        }
      }
    }
  }, [loanDetails]);

  if (isGetOver) {
    return (
      <React.Fragment>
        {isDataAvaiilable ? (
          <div className="w-full block mb-12">
            {loanDetails.map((each, index) => {
              return <LoanDetails each={each} key={index} index={index} />;
            })}

            <PopUp type={type} text={text} setShow={setShow} show={show} />
          </div>
        ) : (
          <p className="w-full text-center font-roboto font-bold text-black-500 text-base items-center mt-9">
            No Data Available
          </p>
        )}
      </React.Fragment>
    );
  } else {
    return loading;
  }
};

const GetPropertyDetails = ({
  setFullImage,
  setIsError,
  setFile,
  currentAction,
  current,
  setCurrentAction
}) => {
  const [propertydata, setPropertyData] = useState([]);
  const [propertySummary, setPropertySummary] = useState({});
  const [type, setType] = useState('loading');
  const [text, setText] = useState('loading');
  const [show, setShow] = useState(false);
  const [isGetOver, setIsGetOver] = useState(false);
  const [isDataAvailable, setDataAvailable] = useState(false);
  const [updateTrigger, setUpdateTrigger] = useState(false);
  const { professional_data, professional_container, widthFit } = styles;
  const isReadOnly = useContext(ReadOnly);

  let propertDetailsApi = doc => {
    setType('loading');
    setText('loading...');
    setShow(true);
    getInPrincipleDocs(getApplicantionInfo().leadId, doc)
      .then(res => {
        if (res.error) {
          throw new Error(res);
        }
        setShow(false);
        setPropertyData(res);
        setIsGetOver(true);
      })
      .catch(error => {
        setIncomeData([]);
        if (error?.response?.data?.status === 403) {
          setType('fail');
          setText(
            error?.response?.data?.message.toString() ||
              'Something went wrong . .'
          );
          setShow(true);
        }
        setIsGetOver(true);
      });
  };

  useEffect(() => {
    if (currentAction === 'Summary') {
      if (_.isEmpty(propertySummary)) {
        setIsGetOver(false);
        getPropertyDetails(getApplicantionInfo().leadId)
          .then(res => {
            setPropertySummary(res);
            setShow(false);
            setIsGetOver(true);
          })
          .catch(err => {
            setIsGetOver(true);
            setType('fail');
            setText(
              err?.response?.data?.message.toString() ||
                'Something went wrong . . '
            );
            setShow(true);
          });
      }
    } else {
      if (!isDataAvailable) {
        setIsGetOver(false);
        propertDetailsApi('cost-sheet');
      }
    }
  }, [currentAction]);

  useEffect(() => {
    if (propertydata) {
      for (let i = 0; i < propertydata.length; i++) {
        if (propertydata[i].applicantDocs.length > 0) {
          setDataAvailable(true);
          break;
        } else {
          setDataAvailable(false);
        }
      }
    }
  }, [propertydata]);
  if (isGetOver) {
    if (currentAction === 'Summary')
      return (
        <div className="w-full bg-white my-3 capitalize mb-12">
          <div className="w-full px-4 pb-5  bg-white shadow-md  rounded-md border border-grey-1009">
            <div className={`block w-12/12  my-2 ${professional_data}`}>
              <CardHeading heading="Product Name" />

              <p className="text-back-400 font-roboto  font-bold  text-md">
                {propertySummary?.loanProduct || 'NA'}
              </p>
            </div>
            <div className={`block w-12/12  mt-4 ${professional_data}`}>
              <CardHeading heading="Property Details" />
            </div>
            <div className={`w-12/12 flex flex-wrap ${professional_container}`}>
              <div className={`block w-1/4  my-2 ${professional_data}`}>
                <p className="text-grey-1003 font-roboto font-normal text-sm">
                  Property Type
                </p>
                <p className="text-black-400 font-roboto  font-medium ">
                  {propertySummary?.propertyDetails?.propertyType || 'NA'}
                </p>
              </div>
              <div className={`block w-1/4  my-2 ${professional_data}`}>
                <p className="text-grey-1003 font-roboto font-normal text-sm">
                  Completion Status
                </p>
                <p className="text-black-400 font-roboto  font-medium ">
                  {propertySummary?.propertyDetails?.completionStatus
                    ?.underDevelopment
                    ? 'Under Development'
                    : 'Completed'}
                </p>
              </div>
              {propertySummary?.propertyDetails?.completionStatus
                ?.underDevelopment && (
                <div className={`block w-1/4  my-2 ${professional_data}`}>
                  <p className="text-grey-1003 font-roboto font-normal text-sm">
                    Percentage Completed
                  </p>
                  <p className="text-black-400 font-roboto  font-medium">
                    {`${propertySummary?.propertyDetails?.completionStatus
                      ?.percentageCompleted + '%' || 'NA'}`}
                  </p>
                </div>
              )}
              {propertySummary?.propertyDetails?.completionStatus
                ?.underDevelopment && (
                <div className={`block w-1/4  my-2 ${professional_data}`}>
                  <p className="text-grey-1003 font-roboto font-normal text-sm">
                    Possession Date
                  </p>
                  <p className="text-black-400 font-roboto  font-medium">
                    {`${propertySummary?.propertyDetails?.completionStatus
                      ?.possessionDate && 'NA'}`}
                  </p>
                </div>
              )}
              {propertySummary?.propertyDetails?.completionStatus
                ?.underDevelopment && (
                <div className={`block w-1/4  my-2 ${professional_data}`}>
                  <p className="text-grey-1003 font-roboto font-normal text-sm">
                    Developer Name
                  </p>
                  <p className="text-black-400 font-roboto  font-medium">
                    {`${propertySummary?.propertyDetails?.devDetails?.name ||
                      'NA'}`}
                  </p>
                </div>
              )}
              {propertySummary?.propertyDetails?.completionStatus
                ?.underDevelopment && (
                <div className={`block w-1/4  my-2 ${professional_data}`}>
                  <p className="text-grey-1003 font-roboto font-normal text-sm">
                    Project Name
                  </p>
                  <p className="text-black-400 font-roboto  font-medium">
                    {`${propertySummary?.propertyDetails?.devDetails
                      ?.projectName || 'NA'}`}
                  </p>
                </div>
              )}
              {propertySummary?.propertyDetails?.completionStatus
                ?.underDevelopment && (
                <div className={`block w-1/4  my-2 ${professional_data}`}>
                  <p className="text-grey-1003 font-roboto font-normal text-sm">
                    RERA No
                  </p>
                  <p className="text-black-400 font-roboto  font-medium">
                    {`${propertySummary?.propertyDetails?.devDetails
                      ?.reraNumber || 'NA'}`}
                  </p>
                </div>
              )}
            </div>
            <div className={`block w-12/12  mt-4 ${professional_data}`}>
              <CardHeading heading="Property Dimensions" />
            </div>
            <div className={`w-12/12 flex flex-wrap ${professional_container}`}>
              <div className={`block w-1/4  my-2 ${professional_data}`}>
                <p className="text-grey-1003 font-roboto font-normal text-sm">
                  built Up Area
                </p>
                <p className="text-black-400 font-roboto  font-medium ">
                  {`${propertySummary?.propertyDetails?.dimensions
                    ?.builtUpArea || 'NA'}`}
                </p>
              </div>
              <div className={`block w-1/4  my-2 ${professional_data}`}>
                <p className="text-grey-1003 font-roboto font-normal text-sm">
                  carpet Area
                </p>
                <p className="text-black-400 font-roboto  font-medium ">
                  {`${propertySummary?.propertyDetails?.dimensions
                    ?.carpetArea || 'NA'}`}
                </p>
              </div>
              <div className={`block w-1/4  my-2 ${professional_data}`}>
                <p className="text-grey-1003 font-roboto font-normal text-sm">
                  plot Area
                </p>
                <p className="text-black-400 font-roboto  font-medium ">
                  {`${propertySummary?.propertyDetails?.dimensions?.plotArea ||
                    'NA'}`}
                </p>
              </div>
              <div className={`block w-1/4  my-2 ${professional_data}`}>
                <p className="text-grey-1003 font-roboto font-normal text-sm">
                  plot No
                </p>
                <p className="text-black-400 font-roboto  font-medium ">
                  {`${propertySummary?.propertyDetails?.dimensions?.plotNo ||
                    'NA'}`}
                </p>
              </div>
              <div className={`block w-1/4  my-2 ${professional_data}`}>
                <p className="text-grey-1003 font-roboto font-normal text-sm">
                  block No
                </p>
                <p className="text-black-400 font-roboto  font-medium ">
                  {`${propertySummary?.propertyDetails?.dimensions?.blockNo ||
                    'NA'}`}
                </p>
              </div>
              <div className={`block w-1/4 my-2 ${professional_data}`}>
                <p className="text-grey-1003 font-roboto font-normal text-sm">
                  floor No
                </p>
                <p className="text-black-400 font-roboto  font-medium ">
                  {`${propertySummary?.propertyDetails?.dimensions?.floorNo ||
                    'NA'}`}
                </p>
              </div>
              <div className={`block w-1/4 my-2 ${professional_data}`}>
                <p className="text-grey-1003 font-roboto font-normal text-sm">
                  house No
                </p>
                <p className="text-black-400 font-roboto  font-medium ">
                  {`${propertySummary?.propertyDetails?.dimensions?.houseNo ||
                    'NA'}`}
                </p>
              </div>
              <div className={`block w-1/4  my-2 ${professional_data}`}>
                <p className="text-grey-1003 font-roboto font-normal text-sm">
                  plc
                </p>
                <p className="text-black-400 font-roboto  font-medium ">
                  {propertySummary?.propertyDetails?.dimensions?.plc
                    ? '₹ '
                    : null}
                  {`${numberFormat(propertySummary?.propertyDetails?.dimensions)
                    ?.plc || 'NA'}`}
                </p>
              </div>
              <div className={`block w-1/4  my-2 ${professional_data}`}>
                <p className="text-grey-1003 font-roboto font-normal text-sm">
                  floor Rise
                </p>
                <p className="text-black-400 font-roboto  font-medium ">
                  {propertySummary?.propertyDetails?.dimensions?.floorRise
                    ? '₹ '
                    : null}
                  {`${numberFormat(
                    propertySummary?.propertyDetails?.dimensions?.floorRise
                  ) || 'NA'}`}
                </p>
              </div>
            </div>
            <div className={`block w-12/12  mt-4 ${professional_data}`}>
              <CardHeading heading="Property Cost" />
            </div>
            <div className={`w-12/12 flex flex-wrap ${professional_container}`}>
              <div className={`block w-1/4 my-2 ${professional_data}`}>
                <p className="text-grey-1003 font-roboto font-normal text-sm">
                  Market Value
                </p>
                <p className="text-black-400 font-roboto  font-medium ">
                  {propertySummary?.propertyDetails?.dimensions?.marketValue
                    ? '₹ '
                    : null}
                  {`${numberFormat(
                    propertySummary?.propertyDetails?.dimensions?.marketValue
                  ) || 'NA'}`}
                </p>
              </div>

              <div className={`block w-1/4  my-2 ${professional_data}`}>
                <p className="text-grey-1003 font-roboto font-normal text-sm">
                  Total Cost
                </p>
                <p className="text-black-400 font-roboto  font-medium ">
                  {propertySummary?.totalCost ? '₹ ' : null}
                  {numberFormat(propertySummary?.totalCost) || 'NA'}
                </p>
              </div>
            </div>
            {/* address */}
            <div className="w-full  max-w-5xl my-2">
              <CardHeading heading="Property Address" />

              {!propertySummary?.address?.line1 &&
                !propertySummary?.address?.line2 &&
                !propertySummary?.address?.city &&
                !propertySummary?.address?.state &&
                !propertySummary?.address?.pinCode && (
                  <p className="text-black-400 font-roboto  font-medium ">NA</p>
                )}
              <p className="text-black-400 font-roboto  font-medium mt-1">
                {`${propertySummary?.address?.line1 || ''}` +
                  ' ' +
                  `${propertySummary?.address?.line2 || ''}` +
                  ' ' +
                  `${propertySummary?.address?.city || ''}` +
                  ' ' +
                  `${propertySummary?.address?.state || ''}` +
                  '-' +
                  `${propertySummary?.address?.pinCode || ''}`}
              </p>

              <CardHeading heading="Property title" />

              <p className="text-black-400 font-roboto  font-medium mt-1 ">
                {`${propertySummary?.title || 'NA'}`}
              </p>
            </div>
          </div>
          <PopUp type={type} text={text} setShow={setShow} show={show} />
        </div>
      );
    else
      return (
        <React.Fragment>
          {!isDataAvailable ? (
            <p className="w-full text-center font-roboto font-bold text-black-500 text-base items-center mt-9">
              No Data Available
            </p>
          ) : (
            <div className={`${widthFit}`}>
              <div className="text-green-600 text-xl font-roboto font-bold mt-5 mb-4">
                Property Details
              </div>
              {propertydata.map((each, index) => {
                return each.applicantDocs?.map((every, innerIndex) => {
                  let costSheetDocId = every?.link?.docId;
                  return (
                    <div className="flex">
                      <CMDashboardIncomeData
                        key={innerIndex}
                        updateTrigger={updateTrigger}
                        setUpdateTrigger={setUpdateTrigger}
                        fileTitle={`${currentAction}${
                          every?.link?.tag ? ` - ${every?.link?.tag}` : ''
                        }`}
                        docId={every?.link?.docId}
                        setFullImage={setFullImage}
                        setIsError={setIsError}
                        setFile={setFile}
                        file={every?.link?.url}
                        tag={every?.link?.tag}
                        verified={every?.verified}
                      />
                      {!isReadOnly ? (
                        <React.Fragment>
                          {each?.applicantDocs.length > 0 && (
                            <CommonComment passAnyDocId={costSheetDocId} />
                          )}
                        </React.Fragment>
                      ) : null}
                    </div>
                  );
                });
              })}

              <PopUp type={type} text={text} setShow={setShow} show={show} />
            </div>
          )}
        </React.Fragment>
      );
  } else {
    return loading;
  }
};

const CreditReport = () => {
  const [type, setType] = useState('loading');
  const [text, setText] = useState('Loading...');
  const [show, setShow] = useState(false);
  const [mainApplicant, setMainAppliacant] = useState(false);
  const [coApplicants, setCoApplicants] = useState([]);

  const seperateApplicantAndMain = allApplicants => {
    let applicant = [];
    for (let i = 0; i < allApplicants.length; i++) {
      if (allApplicants[i]?.mainApplicant) {
        setMainAppliacant(allApplicants[i]);
      } else {
        applicant.push(allApplicants[i]);
      }
    }
    setCoApplicants(applicant);
  };

  useEffect(() => {
    setType('loading');
    setText('getting data Please Wait...!');
    setShow(true);
    getLeadProfileStatus(getApplicantionInfo().leadId)
      .then(res => {
        if (res.error) {
          throw new Error(res);
        }
        setShow(false);
        if (Array.isArray(res?.applicantsData)) {
          seperateApplicantAndMain(res.applicantsData);
        }
      })
      .catch(error => {
        setShow(false);
      });
  }, []);

  const DisplayCreditSummary = creditData => {
    let creditScoreGroup = 'Excellent';

    const findCreditScoreGroup = () => {
      const creditScore = parseInt(creditData?.creditData?.creditScore);
      if (creditScore < 580)
        creditScoreGroup = <span className="text-red-700">Very Poor</span>;
      else if (creditScore < 670 && creditScore >= 580)
        creditScoreGroup = <span className="text-orange-1200">Poor</span>;
      else if (creditScore < 740 && creditScore >= 670)
        creditScoreGroup = <span className="text-yellow-100">Fair</span>;
      else if (creditScore < 800 && creditScore >= 740)
        creditScoreGroup = (
          <span className="text-green-dimgreen">Very Good </span>
        );
      else if (creditScore >= 800)
        creditScoreGroup = <span className="text-green-1500">Exceptional</span>;
    };
    try {
      parseInt(creditData?.creditData?.creditScore);
      findCreditScoreGroup();
    } catch {
      creditScoreGroup = <span className="text-black-0">-----</span>;
    }

    if (!creditData?.creditData?.creditScore)
      return (
        <div className="font-roboto font-medium text-sm text-left mt-4 mb-10 text-black-0  ">
          No Credit Score Available
        </div>
      );

    const viewCreditReport = async () => {
      let appData = getApplicantionInfo();
      appData['leadApplicantId'] = creditData?.creditData?.id;
      setApplicantionInfo(appData);
      navigate('/app/cm/lead/creditReport?backPage=cmView');
    };

    return (
      <div className="w-full mt-4 mb-6 px-4 bg-skyBlue-100 pb-6 pt-2 rounded max-w-md">
        <p
          className="font-roboto font-normal text-blue-900 cursor-pointer float-right text-sm"
          onClick={() => viewCreditReport()}
        >
          View Credit Report
        </p>

        <div className="flex items-center w-full">
          <div className="block">
            <p className="font-roboto font-normal text-grey-1003 text-sm  mr-auto text-left">
              Credit Score
            </p>
            <p className="font-roboto font-bold text-black text-xl text-left">
              {creditData?.creditData?.creditScore}/900
            </p>
          </div>
          <div className="ml-20 ">
            <p className="font-roboto font-semibold text-green-flagGreen text-lg mr-auto">
              {creditScoreGroup}
            </p>
          </div>
        </div>
        <div className="w-full text-left mr-auto max-w-md inline-flex items-center text-center ml-10 mt-1">
          <span className="">Powered by</span>
          <img className="w-25 max-w-md " src={experian} />
        </div>
      </div>
    );
  };
  return (
    <div className="w-full mt-3 pt-3">
      <div className="w-full">
        <p className="text-black-400 font-roboto font-semibold text-md  text-base text-left ">
          Main Applicant
        </p>
        <div className="w-full">
          <DisplayCreditSummary creditData={mainApplicant} />
        </div>
      </div>

      {coApplicants.map((each, index) => (
        <div className="w-full my-3" key={index}>
          <p className="text-black-400 font-roboto font-semibold text-md  text-base text-left">
            Co-Applicant {index + 1}
          </p>
          <div className="">
            <DisplayCreditSummary creditData={each} />
          </div>
        </div>
      ))}
      <PopUp type={type} text={text} setShow={setShow} show={show} />
    </div>
  );
};

const HardRejection = ({ show, setShow }) => {
  const [message, setmessage] = useState('');
  const [type, setType] = useState('loading');
  const [text, setText] = useState('loading please wait...');
  const [showPopup, setShowPopup] = useState(false);
  const [basicData, setBasicData] = useState({});
  const [isError, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [isTouched, setIsTouched] = useState(false);
  const [showConfirmation, setShowConfirmRejection] = useState(false);

  useEffect(() => {
    getUserdata();
  }, []);

  const getUserdata = () => {
    setType('loading');
    setText('getting the Application Details. please Wait..');
    setShowPopup(true);
    getInfoForInPrinciple(getApplicantionInfo().leadId, 'basic-information')
      .then(res => {
        if (res.error) {
          throw new Error(res);
        }
        setBasicData(res);
        setShowPopup(false);
      })
      .catch(error => {
        setShowPopup(false);
      });
  };

  const rejectTheApplication = () => {
    setShowConfirmRejection(false);
    setError(false);
    setType('loading');
    setText('rejecting the applicartion! Please wait..');
    setShowPopup(true);
    hardRejectTheApplication(getApplicantionInfo().leadId, message)
      .then(res => {
        if (res.error) throw new Error(res);
        setShowPopup(false);
        setShow(false);
        navigate('/app/dashboard');
      })
      .catch(error => {
        setShowPopup(false);
        setShow(false);
      });
  };

  const handleRejection = () => {
    if (!isTouched)
      return setError(true), setIsTouched(true), setErrorMessage('required!');
    if (isError) return;
    setShowConfirmRejection(true);
  };

  useEffect(() => {
    if (!isTouched || (message && message.length > 7)) return setError(false);
    else if (!message) setErrorMessage('required!');
    else setErrorMessage('Too Short!');
    setError(true);
  }, [message]);
  return (
    <Modal
      show={show}
      setShow={setShow}
      styleContainer={{
        minWidth: '300px'
      }}
      noCloseBtn={true}
      title="Reject Application"
      titleStyle={{ color: '#2d3748', fontSize: '17px', fontWeight: '400' }}
    >
      <div className="w-full text-center">
        <hr className="border-grey-400 -mt-1 mb-5" />
        <div className="mb-5 mt-2">
          <CancelRoundedIcon style={{ color: 'red', fontSize: '60px' }} />
        </div>
        <p className="font-roboto text-sm text-black-1013 text-left">
          Do you want to reject the application of
          <span className="ml-1 font-medium capitalize">
            {`${_.get(basicData, 'mainApplicant.name.firstName', '')}
            ${_.get(basicData, 'mainApplicant.name.lastName', '')}`}
          </span>
          ?
        </p>
        <p className="font-roboto text-sm text-black-1013 text-left mt-4">
          Please give a reason.
        </p>
        <textarea
          name="message_block"
          placeholder="write here..."
          value={message}
          className={`w-full mt-1 border  rounded px-3 py-4 ${
            isError ? 'border-red-500' : 'border-grey-400'
          }`}
          style={{ minHeight: '100px' }}
          onChange={e => setmessage(e.target.value)}
          onFocus={e => setIsTouched(true)}
        ></textarea>
        <p className="text-sm text-left px-1  font-roboto font-normal text-red-500">
          {isError ? errorMessage : null}
        </p>
        <div className="w-full flex mb-4 mt-7">
          <button
            type="button"
            className="  py-2 text-white bg-red-500 rounded text-base px-6 ml-auto"
            onClick={handleRejection}
          >
            Reject
          </button>
          <button
            type="button"
            className={`px-6 ml-2  py-2 text-white bg-green-900 rounded text-base`}
            onClick={() => setShow(false)}
          >
            Cancel
          </button>
        </div>
        <PopUp
          type={type}
          text={text}
          setShow={setShowPopup}
          show={showPopup}
        />
        <Modal show={showConfirmation} setShow={setShowConfirmRejection}>
          <div className="w-full">
            <p className="font-roboto font-medium text-sm text-grey-300 text-center">
              Do you want to permanently reject this application?
            </p>
            <p className="font-roboto font-normal my-3 text-sm   text-grey-300">
              You won't be able to edit this application in future!
            </p>
            <div className="mt-4">
              <button
                type="button"
                className="  py-2 text-white bg-red-500 rounded text-base px-6 ml-auto"
                onClick={rejectTheApplication}
              >
                Yes, Reject
              </button>
              <button
                type="button"
                className={`px-6 ml-2  py-2 text-white bg-green-900 rounded text-base`}
                onClick={() => setShow(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </Modal>
      </div>
    </Modal>
  );
};
export default React.memo(withErrorHandler(CMDetailView));
